export const LABELS = {
  issueBodyHeader: 'Description',
  issueBodyPlaceholder: 'Type your description here…',
  issueBodyHeaderActions: 'Issue body actions',
  staleBodyErrorPrefix: 'GraphQL error: STALE_DATA',
  convertButton: (taskName: string) => `Create an issue with the title "${taskName}"`,
  authorLabel: (isBot: boolean) => `${isBot ? 'bot' : 'mannequin'}`,
  copilotCTAButton: 'Write with Copilot',
}
